/**
 * Created by 58 on 2016/9/26.
 */
/*require('./../style/contact-window.less');*/
var Component = require('./Component'),
  $ = require('jQuery'),
  template = require('../template/contact-window.html'),
  SessionGroup = require('./session/SessionGroup'),
  SessionList = require('./session/SessionList'),
  OrganizStructure = require('./session/OrganizStructure1'),
  PersonSearch = require('./PersonSearch'),
  AppPosition = require('./../constant/AppPosition'),
  dispatcher = require('./../global/dispatcher'),
  //stat = require('./../global/stat'),
  //StatPoint = require('./../constant/StatPoint'),
  ActionType = require('./../constant/ActionType'),
  AppStatus = require('./../constant/AppStatus'),
  Timer = require('./../../lib/Timer'),
  //session = require('./../store/session-new'),
  Scrollbar = require('./Scrollbar'),
  gdic = require('./../global/globalDic'),
  config = require('../global/config'),
  falseNewsDic = require('./../global/falseNewsDic');
var utils = require('./../global/utils');
var isEmpty = utils.isEmpty;

var gatherFalseLastMsgs = falseNewsDic.gatherFalseLastMsgs;

var ContactWindow = function (options) {
  this._type = "sessionlist"; //session和组织架构
  this._state = "session";    //组和会话

  (function (self) {
    var defaults = {
      template: template,
      getMoreSession: function (cb) {
        cb([], false);
      }
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
    // 设置默认引导文案
    if (!config['default-contactwindow']) {
      return;
    }
    var $element = self.getElement();
    if (config['default-contactwindow'].img) {
      $element.find(".im-contactwindow-defaultImg").css({
        "backgroundImage": "url(" + config['default-contactwindow'].img + ")",
        "backgroundSize": "contain",
        "backgroundPosition": "0 0"
      });
    }
    if (config['default-contactwindow'].tip) {
      $element.find(".im-des-line1").text(config['default-contactwindow'].tip);
    }
  })(this);

  // 全屏、缩小、切换session和组织结构
  (function (self) {
    self._element.click(function (e) {
      e.preventDefault();
      var $target = $(e.target),
        fullScreenUrl,
        switcher;
      if ($target.hasClass("im-switchsize-btn") || $target.hasClass("im-contactwindow-switch-icon") || (!$target.hasClass('im-contactwindow-fullscreen') && !$target.hasClass('im-contactwindow-fullscreen-icon') && $('.im-switchsize-btn').hasClass('im-contactwindow-normalize'))) {
        self.triggerEvent("imMinimize");
      }
      if ($target.hasClass('im-contactwindow-fullscreen') || $target.hasClass('im-contactwindow-fullscreen-icon')) {
        fullScreenUrl = config['maxUrl'];
        window.open(fullScreenUrl);

        //埋点统计（居中点击）
        //stat.report(StatPoint.center_btn_click);
        if (window.WMDA_REPORT) {
          window.WMDA_REPORT('custom', { event_id: '5' })
        }
      }
      else if ($target.hasClass('im-contactwindow-sessionlist') || $target.hasClass('im-contactwindow-sessionlist-icon')) {
        switcher = $target.hasClass('im-contactwindow-sessionlist-icon') ? $target : $target.children();
        if (self._type == "organization") {
          switcher.addClass("im-active").parent().siblings().children().removeClass("im-active");
          self.switchToSession();
          return false;
        }
        self._children['sessionlist-scrollbar'].scrollToTop();
      }
      else if ($target.hasClass('im-contactwindow-organiz') || $target.hasClass('im-contactwindow-organization-icon')) {
        switcher = $target.hasClass('im-contactwindow-organization-icon') ? $target : $target.children();
        if (self._type == "sessionlist") {
          switcher.addClass("im-active").parent().siblings().children().removeClass("im-active");
          self.switchToOrganization();
          return false;
        }
        self._children['organization-scrollbar'].scrollToTop();
      }
      else if ($target.hasClass('im-contact-img')) {
        self._children['sessionlist-scrollbar'].scrollToTop();
      }
    });

    //禁用拖拽事件
    self._element.on('dragover', function (e) {
      e.preventDefault();
    });
    self._element.on('drop', function (e) {
      e.preventDefault();
    });
  })(this);

  // 清楚未读数功能
  (function (self) {
    var $element = self.getElement();
    var $clearBtn = $element.find(".im-clearmsg-btn");
    $clearBtn.on('click', function (e) {
      e = e || window.event;
      e.stopPropagation();
      dispatcher.dispatch({
        type: ActionType.CLEAR_ALL_UNREAD_MSGS,
        data: ''
      })
    })
  })(this);
  //点击我的收藏
  (function (self) {
    if (!isEmpty(self._options.me)) {
      var $element = self.getElement();
      var $collectBtn = $element.find(".im-my-collect-btn");
      if (self._options.me.is_anonymous_login) {
        $collectBtn.hide();
      } else {
        $collectBtn.addClass('im-my-collect-btn-show').on('click', function (e) {
          e = e || window.event;
          e.stopPropagation();
          // 点击我的收藏
          dispatcher.dispatch({
            type: ActionType.GET_MY_COLLECTION,
            data: ''
          })
        });
      }
    }
  })(this);

  // 添加会话假消息
  (function () {
    var me = config['me']();
    var meKey = me.user_id + '@' + me.user_source;
    var falseLastMsgs = gatherFalseLastMsgs(meKey);
    for (var tmpKey in falseLastMsgs) {
      if (tmpKey) {
        gdic.set('tmpMsg-session-' + tmpKey, falseLastMsgs[tmpKey]);
      }
    }
  })();

  // 添加sessionList,session scrollbar
  (function (self) {
    var sessionList = new SessionList({
      is_vm: true,
      getMoreSession: self._options.getMoreSession
    });

    self._element.find('.im-session-list-wrap').append(sessionList.getElement());

    sessionList.addEventListener("listEmpty", function () {
      self.getElement().find(".im-contactwindow-default").show();
    });

    sessionList.addEventListener("setScrollTop", function (data) {
      if (data) {
        self._children['sessionlist-scrollbar'].scroll(data);
      }
    });
    sessionList.addEventListener("voidlist", function () {
      self.addVoidBackground(true);
    });

    self._children['sessionList'] = sessionList;

    var scrollbar = new Scrollbar({
      window: self._element.find(".im-session-list-wrap"),
      content: self._element.find(".im-session-list")
    });
    self._element.find(".im-session-list-wrap").append(scrollbar.getElement());
    self._children['sessionlist-scrollbar'] = scrollbar;

    setTimeout(function () {
      scrollbar.init();
    }, 0);

    scrollbar.addEventListener("scrolled", function (scrolltop) {
      var wrapHeight = self.getElement().find(".im-session-list-wrap").height();
      var listHeight = self.getElement().find(".im-session-list").height();
      if (listHeight < wrapHeight) {
        return false
      }
      if (listHeight - wrapHeight - scrolltop <= 5) {
        self._children['sessionList'].addLoading();
      }
    });

  })(this);

  // 组织架构,scrollbar
  (function (self) {
    if (!config.organization.enabled) {
      self.getElement().find(".im-contactwindow-organization").hide();
      self.getElement().find(".im-session-list-wrap").addClass("im-contactwindow-noOrgan");
      self.getElement().find(".im-contactwindow-body").addClass("im-contactwindow-noOrgan");
      self.getElement().find(".im-contact-group-detail").addClass("im-contactwindow-noOrgan");
      self.getElement().find(".im-contactwindow-header .im-clearmsg-btn").addClass("im-contactwindow-noOrgan");
      self.getElement().find(".im-contactwindow-header .im-my-collect-btn").addClass("im-contactwindow-noOrgan");
      return false
    }
    //self.getElement().find(".im-contactwindow-header").hide();
    self.getElement().find(".im-contactwindow-body").addClass("im-contactwindow-nohearder");
    var organizstructure = new OrganizStructure();
    self._element.find('.im-contactwindow-body').append(organizstructure.getElement());
    self._children['organization'] = organizstructure;

    var scrollbar = new Scrollbar({
      window: self._element.find(".im-organization-structure"),
      content: self._element.find(".im-organization-list")
    });

    self._element.find(".im-organization-structure").append(scrollbar.getElement());
    self._children['organization'].addEventListener("contentHeightChange", function () {
      scrollbar.calHeight();
    });
    self._children['organization-scrollbar'] = scrollbar;

    setTimeout(function () {
      scrollbar.init();
    }, 0);
  })(this);

  // 全局事件
  (function (self) {
    dispatcher.register(function (action) {
      var data = action.data;
      switch (action.type) {
        case ActionType.UNREAD_CHANGE:
          var tipsInfo;
          var position = gdic.get('position');
          if (data.amount && !self.getElement().find(".im-contactwindow-header").hasClass('im-normal') && position != AppPosition.CENTER) {
            tipsInfo = "有新消息";
          } else {
            tipsInfo = "微聊";
          }
          self.setData({
            unreadMsg: data.amount,
            tipsInfo: tipsInfo
          });
          break;
        case ActionType.APP_STATUS_CHANGE:

          var $state = self.getElement().find(".im-switchsize-btn");
          if (data == AppStatus.NORMAL) {
            $state.removeClass("im-contactwindow-normalize");
            self.getElement().find(".im-contactwindow-header .im-my-collect-btn").removeClass("im-contactwindow-noOrgan");
            self.getElement().find(".im-contactwindow-header").addClass('im-normal');
            self.getElement().find(".im-contactwindow-info").text('微聊');
          } else if (data == AppStatus.MIN) {
            var unreadMsg = self._data.unreadMsg + '';
            var hasNewMsg = false;
            if (unreadMsg.length && (!isNaN(unreadMsg) && Number(unreadMsg) > 0) && /^[0-9]+(\+)*$/.test(unreadMsg)) {
              hasNewMsg = true;
            }
            $state.addClass("im-contactwindow-normalize");
            self.getElement().find(".im-contactwindow-header").removeClass('im-normal');
            self.getElement().find(".im-contactwindow-header .im-my-collect-btn").addClass("im-contactwindow-noOrgan");

            self.getElement().find(".im-contactwindow-info").text(hasNewMsg ? '有新消息' : '微聊');
          }
          break;
        case ActionType.SESSION_CHILDREN_CHANGE:
          var node = action.data;
          if (!node.group && !node.contact) {
            self.addVoidBackground(false);
            self._children["sessionList"].setSessions(node.children, function() {
              self._children["sessionlist-scrollbar"].calHeight();
            });
          }
          else if (node.group) {
            if (self._state === "session") {
              return false;
            } else if (self._state === "group") {
              self.gotoGroupDetail(node);
            }
          }
          break;
        case ActionType.SESSION_CLICK:
          var session = action.data;
          if (session && session.group) {
            self.gotoGroupDetail(session);
          }
          break;
        default:
          break;
      }
    });
  })(this);

  // 人员搜索
  (function (self) {
    if (!config.organization.enabled) {
      return false
    }
    var contactWindow = self.getElement(),
      personsearch = new PersonSearch({
        search: config.organization.search
      }),
      searchInput = contactWindow.find(".im-contactWindow-header-searchinput-input");
    contactWindow.find(".im-contactWindow-search").append(personsearch.getElement());
    searchInput.keyup(function (e) {
      e.stopPropagation();
      var keycode = e.which,
        $this = $(this),
        value = $.trim($this.val());
      personsearch.keyOperation(keycode, value);
      // $this.focus();
    });
    personsearch.addEventListener("personCheck", function () {
      searchInput.val("");
    });

    $(window).click(function (e) {
      if (personsearch._open && !$.contains(personsearch.getElement()[0], e.target)) {
        if (!$(e.target).is(searchInput)) {
          personsearch.close();
        }
      }
    });
    self._children['personsearch'] = personsearch;
  })(this);
};

ContactWindow.prototype = Object.create(Component.prototype);

ContactWindow.prototype.render = function () {
  var $element = this.getElement(),
    data = this._data,
    enabled = config.organization.enabled;
  $element.find(".im-contactwindow-info").text(data.tipsInfo);
  if (!!data.unreadMsg) {
    data.unreadMsg = data.unreadMsg > 99 ? '99+' : data.unreadMsg;
    if (enabled) {
      $element.find(".im-max-newmsg-count").text(data.unreadMsg).removeClass("im-hide");
    } else {
      $element.find(".im-mini-newmsg-count").text(data.unreadMsg).removeClass("im-hide");
    }
  } else {
    if (enabled) {
      $element.find(".im-max-newmsg-count").addClass("im-hide");
    } else {
      $element.find(".im-mini-newmsg-count").addClass("im-hide");
    }
  }
};

// 切换到消息会话组
ContactWindow.prototype.gotoGroupDetail = function (session) {
  var self = this;
  this._state = "group";
  var sessionGroup = this._children['group-session-detail'];
  if (!sessionGroup) {
    sessionGroup = new SessionGroup();
    this._element.find(".im-contactwindow-body").append(sessionGroup.getElement());
    this._children['group-session-detail'] = sessionGroup;
  }
  self.getElement().find(".im-session-list-wrap").addClass("im-contactwindow-switch-group");
  setTimeout(function () {
    if (self._state === "group") {
      self.getElement().find(".im-contact-group-detail").addClass("im-contactwindow-switch-group");
    } 
  }, 0);
  sessionGroup.setSession(session);
  sessionGroup.addEventListener("return", self.groupReturn.bind(self));
};

// 返回
ContactWindow.prototype.groupReturn = function () {
  var self = this;
  self._element.find(".im-contact-group-detail").removeClass("im-contactwindow-switch-group");
  self._element.find(".im-session-list-wrap").removeClass("im-contactwindow-switch-group");
  self._state = "session";
}

// 切换到会话列表
ContactWindow.prototype.switchToSession = function () {
  this._type = "sessionlist";
  this._children["organization"].hide();
  this.getElement().find(".im-session-list-wrap").show();
  this._children['sessionlist-scrollbar'].calHeight();
};

// 切换到组织结构
ContactWindow.prototype.switchToOrganization = function () {
  if (this._children["organization"]) {
    this._type = "organization";
    this.getElement().find(".im-session-list-wrap").hide();
    this._children["organization"].show();
    this._children['organization-scrollbar'].init();
    this._children['organization-scrollbar'].calHeight();
    return false;
  }
  // alert("未获取到组织结构！");
};

// 显示无联系人默认背景
ContactWindow.prototype.addVoidBackground = function (bool) {
  if (bool) {
    this.getElement().find(".im-contactwindow-default").show();
  } else {
    this.getElement().find(".im-contactwindow-default").hide();
  }
};

// 最小化后闪烁提示
ContactWindow.prototype.blinkMinBar = function () {
  var self = this;
  self.resetblinkMinBar();

  (function () {
    var step = 0;
    self._blinkMinBarTimer = new Timer({
      onElapsed: function (cb) {
        step++;
        if (step <= 5) {
          if (step % 2 == 1) {

            $('.im-contactwindow-header').addClass('im-blink');
            if (step == 5) {
              self._blinkMinBarTimer.stop();
            }
          }
          if (step % 2 == 0) {
            //$('.im-contactwindow-header').css('background-color', '#f5f5f5');
            $('.im-contactwindow-header').removeClass('im-blink');
          }
        }
        if (step != 5) {
          cb();
        }
      },
      duration: 1000
    });
  })();
  self._blinkMinBarTimer.start();
};
ContactWindow.prototype.resetblinkMinBar = function () {
  $('.im-contactwindow-header').removeClass('im-blink');
  if (!!this._blinkMinBarTimer) {
    this._blinkMinBarTimer.stop();
  }
};

// 加载会话列表
/*ContactWindow.prototype.addMoreSession = function () {
 this._children['sessionList'].addMoreSession();
 };*/


module.exports = ContactWindow;
